module.exports = __webpack_public_path__ + "img/x-icon.3b3aa36d.svg";